export default __webpack_public_path__ + "static-front/media/IndicatorIcon.22bcff76.svg";